/**
 * +-------------------------------------------------+
 * |                                                 |
 * | Function Global Untuk Pagination dan get Data   |
 * +_________________________________________________+
 * 
 * Asalkan function mixin dan vue componentnya sama pagination bisa berjalan
 */

export const PaginationDataPesertaPesertaRpl = {

    data() {
        return {
            items: [],
            indexed: 0,
            formFilter: {
                idSertifikasiRpl: '',
                status_pembayaran: '',
                periode: ''
            },
            searchDataPesertaRpl: '',
            pageSize: '10',
            currentPageDataPesertaRpl: 0,
            timeout: 0,
            pagination: {
                totalPages: 0
            },
            no: 1
        }
    },

    watch: {
        searchDataPesertaRpl: function(val) {
            clearTimeout(this.timeout);
            var vm = this;
            this.timeout = setTimeout(function() {
                var searchVar = vm.ltrim(vm.searchDataPesertaRpl);
                vm.getData('0', vm.pageSize, searchVar, vm.formFilter.idSertifikasiRpl, vm.formFilter.status_pembayaran, vm.formFilter.periode);
            }, 1000);
        },

        currentPageDataPesertaRpl: function(val) {
            var vm = this;
            var page = val - 1;
            this.indexed = page * 10;
            this.getData(page, vm.pageSize, vm.searchDataPesertaRpl, vm.formFilter.idSertifikasiRpl, vm.formFilter.status_pembayaran, vm.formFilter.periode);
        }
    },

    methods: {
        ltrim(str) {
            if(!str) return str;
            return str.replace(/^\s+/g, '');
        },

        changePageSize(e) {            
            var pageSize = "";
            var vm = this;
            if (e.target.value == "Semua Data") {
                pageSize = "50000";
                this.pageSize = pageSize;
            } else {
                pageSize = e.target.value;
                this.pageSize = pageSize;
            }

            this.getData("0", vm.pageSize, vm.searchDataPesertaRpl, vm.formFilter.idSertifikasiRpl, vm.formFilter.status_pembayaran,vm.formFilter.periode );
        },
    }

}